// Neutraliserer tekst, der ellers ville blive tolket som en formel i Excel/Calc (CSV-injektion).
export function csvSafe(value: string): string {
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}

// Cellen som citeret CSV-felt med dobbelte citationstegn og formelbeskyttelse.
export function csvQuoted(value: string | number | null | undefined): string {
  return `"${csvSafe(String(value ?? '')).replace(/"/g, '""')}"`;
}
